import React, { useEffect } from 'react';
import {
	Dialog,
	DialogActions,
	Button,
	DialogTitle,
	DialogContent,
	IconButton,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import checkIsMobile from 'utils/CheckIsMobile';
import 'assets/scss/info-modal.scss';
import { DATA_LAYERS } from 'constants/DataLayers';
import TagManager from 'react-gtm-module';

type InfoModalProps = {
	title: string;
	content: any;
	buttonLabel: string;
	toggleModal: () => void;
	open: boolean;
	dataLayerKey?: string;
};

export const InfoModal = ({
	open,
	title,
	content,
	buttonLabel,
	toggleModal,
	dataLayerKey,
}: InfoModalProps) => {
	const size = checkIsMobile() ? 'medium' : 'large';

	useEffect(
		() => {
			if (dataLayerKey) {
				TagManager.dataLayer({
					dataLayer: DATA_LAYERS.get(dataLayerKey),
				});
			}
		},
		//eslint-disable-next-line
		[]
	);

	return (
		<Dialog open={open} onClose={toggleModal} className="info-modal info-modal">
			<DialogTitle disableTypography className="info-modal-title title-4 primary-color">
				{title}
			</DialogTitle>
			<IconButton
				aria-label="close"
				style={{ position: 'absolute', top: 0, right: 0 }}
				onClick={toggleModal}
			>
				<CloseIcon />
			</IconButton>
			<div className="info-modal-separador"></div>
			<DialogContent className="info-modal-content body gris-6">{content}</DialogContent>
			<DialogActions>
				<Button
					onClick={toggleModal}
					variant="contained"
					color="primary"
					style={{width: '270px'}}
					size={size}
					//endIcon={<ArrowForwardIcon />}
				>
					{buttonLabel}
				</Button>
			</DialogActions>
		</Dialog>
	);
};
